import { useQuery } from '@tanstack/react-query';

import { BaseError } from '../../helpers/BaseError';

import {
    MessageContentGetResponse,
    TestMessageFilter,
} from '../../models/message-content.model';

import API from '../../services/api';

import messageContentQueryKeys from './_queryKey';

const getMessageContentCount = async (
    id: string,
    formula_id: number,
    filters?: TestMessageFilter,
) => {
    const contentData = { formula_id: formula_id, ...filters };
    const { data } = await API.getMessageContentCount(id, contentData);
    return data;
};

export default function useMessageContentCountQuery(
    id: string,
    formula_id: number,
    filters?: TestMessageFilter,
) {
    return useQuery<MessageContentGetResponse, BaseError, number>({
        queryKey: messageContentQueryKeys.messageContentCount(
            id,
            formula_id,
            filters || {},
        ),
        queryFn: () => getMessageContentCount(id, formula_id, filters),
        enabled: !!id && !!formula_id,
    });
}
